import React from 'react';
import { InvoiceLineItem, SKU } from '../../../../redux/billing/billing.types';
import { Equal, Plus, X } from 'lucide-react';
import { formatCurrency, formatPercentage } from './utils';

interface InvoiceLineItemDetailCalcProps {
  lineItem: InvoiceLineItem;
  sku: SKU;
}

export const InvoiceLineItemDetailCalc: React.FC<InvoiceLineItemDetailCalcProps> = ({
  lineItem,
  sku,
}) => {
  const useOverrideValue = (field: keyof InvoiceLineItem) => {
    const overrideField = `${field}_override` as keyof InvoiceLineItem;
    const overrideValue = lineItem[overrideField];
    return overrideValue !== null && overrideValue !== undefined ? overrideValue : lineItem[field];
  };

  const getRate = () => {
    const amountToBill = useOverrideValue('amount_to_bill') as number;
    const qty = useOverrideValue('qty') as number / 1000;
    return (amountToBill / qty).toFixed(2);
  };

  const isDoNotBill = sku && sku.bill_type === 'do_not_bill';

  return (
    //
    <>
      <div className='flex flex-col'>
        <div className='text-sm font-light text-gray-500'>
          Total
        </div>
        <div className='text-xl font-thin'>
          {formatCurrency(useOverrideValue('advertiser_spend') as number)}
        </div>
        <div className='text-xs font-light text-gray-500'>
          Spend
        </div>
      </div>
      <div>
        <Plus className='h-4 w-4' />
      </div>
      {/* <div className='flex flex-col'>
        <div className='text-sm font-light text-transparent'>
          {'L'}
        </div>
        <div className='text-xl font-thin'>
          {formatPercentage(lineItem.margin_pct_override || lineItem.margin_pct || 0)}
        </div>
        <div className='text-xs font-light text-gray-500'>
          Margin Pct
        </div>
      </div> */}
      <div className='flex flex-col'>
        <div className='text-sm font-light text-transparent'>
          {'L'}
        </div>
        <div className='text-xl font-thin'>
          {formatCurrency(lineItem.margin || 0)}
        </div>
        <div className='text-xs font-light text-gray-500'>
          Margin
          {` (${formatPercentage((useOverrideValue('margin_pct') as number) ?? 0, 0)})`}
        </div>
      </div>
      <div>
        <Equal className='h-4 w-4' />
      </div>
      <div className='flex flex-col'>
        <div className='text-sm font-light text-transparent justify-center items-center'>
          {isDoNotBill ? (
            <span className='text-xs font-light text-gray-500 bg-orange-500 text-white px-0.5 rounded-md'>
              Do Not Bill
            </span>
          ) : (
            'L'
          )}
        </div>
        <div className='text-xl font-thin'>
          {formatCurrency(lineItem.amount_to_bill || 0)}
        </div>
        <div className='text-xs font-light text-gray-500'>
          Total
        </div>
      </div>
      <div className='flex flex-col border-l border-gray-400 ml-2 pl-4'>
        <div className='text-sm font-light text-gray-500'>
          Details
        </div>
        <div className='text-xl font-thin text-center'>
          {((useOverrideValue('qty') as number) / 1000).toFixed(0)}
        </div>
        <div className='text-xs font-light text-gray-500'>
          Quantity
        </div>
      </div>
      <div>
        <X className='h-4 w-4' />
      </div>
      <div className='flex flex-col pl-2'>
        <div className='text-sm font-light text-transparent'>
          {'L'}
        </div>
        <div className='text-xl font-thin'>
          {getRate()}
        </div>
        <div className='text-xs font-light text-gray-500 text-center'>
          Rate
        </div>
      </div>
    </>
  );
};

export default InvoiceLineItemDetailCalc;
